import { provideHttpClient } from "@angular/common/http";
import { ApplicationConfig, importProvidersFrom } from "@angular/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter, withComponentInputBinding } from "@angular/router";

import { SharedModule } from "./shared/shared.module";
import { FaIconLibrary } from "@fortawesome/angular-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { routes } from "./app.routes";

export const appConfig: ApplicationConfig = {
      providers: [
    provideAnimations(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(), 
    importProvidersFrom(SharedModule),

    {
      provide: FaIconLibrary,
      useFactory: () => {
        const library = new FaIconLibrary();
        library.addIcons(faWhatsapp);
        library.addIconPacks(fas); // Añade todos los packs que uses
        return library;
      },
      deps: []
    },
  ]
}